import { EuiStepsHorizontal } from "@inscopix/ideas-eui";
import { useWorkflowEditorTimelineStatus } from "./useWorkflowEditorTimelineStatus";
import { useWorkflowEditorContext } from "components/WorkflowEditor/WorkflowEditorProvider/WorkflowEditorProvider";
import { WORKFLOW_EDITOR_PAGE_CONSTANTS } from "components/WorkflowEditor/WorkflowEditorProvider/WorkflowEditor.store";

export const WorkflowEditorTimeline = () => {
  const page = useWorkflowEditorContext((s) => s.page);
  const timelineStatusByPage = useWorkflowEditorTimelineStatus(page);
  const onClickTimelinePage = useWorkflowEditorContext(
    (s) => s.handleClickTimelinePage,
  );

  return (
    <EuiStepsHorizontal
      steps={WORKFLOW_EDITOR_PAGE_CONSTANTS.WORKFLOW_EDITOR_PAGES.map(
        (page) => {
          const { status, isDisabled } = timelineStatusByPage[page.key];
          return {
            key: page.key,
            title: page.title,
            status: status,
            disabled: isDisabled,
            onClick: () => {
              // disabled status overrides loading visually so we can use this to disable handler for loading states
              if (status !== "loading" && !isDisabled) {
                onClickTimelinePage(page.key);
              }
            },
          };
        },
      )}
    />
  );
};
